import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, useAbilities, useIsPrint, useIsFullScreen, useDisplayChangelog } from "@Hooks";
import {
  Header,
  AdminMenu,
  Notifications,
  Tabs,
  VoiceCallModal,
  VoiceCallsModal,
} from "@Components";
import { HandlingFocusedConversationHandler } from "@Containers";
import { Changelog } from "@Components/dashboard/changelog/changelog";
import { DocumentViewer } from "./document.viewer";
import { Aside } from "@Components/aside";
import { QueuedVoiceCallNotification } from "@Components/notification/queued_voice_call";

export const AppLayout = React.memo(({ children }: React.PropsWithChildren<{}>) => {
  const navigate = useNavigate();
  const auth = useAuth();
  const abilities = useAbilities();
  const location = useLocation();
  const isPrint = useIsPrint();
  const isFullscreen = useIsFullScreen();
  const displayChangelog = useDisplayChangelog();

  const [menuVisible, setMenuVisible] = useState(location.pathname.startsWith("/admin"));
  const toggleMenu = useCallback(() => setMenuVisible(!menuVisible), [setMenuVisible, menuVisible]);

  if (!auth) {
    navigate("/");
    return <></>;
  }

  if (!abilities) return <></>;

  return (
    <HandlingFocusedConversationHandler auth={auth}>
      <DocumentViewer />
      {!isPrint && !isFullscreen && <Header onToggleMenu={toggleMenu} />}
      <VoiceCallModal />
      <VoiceCallsModal />
      {auth.user.main && <Notifications />}
      {auth.user.main && <QueuedVoiceCallNotification />}
      <div className={"content-master-wrp"}>
        {displayChangelog && <Changelog auth={auth} />}
        {!isPrint && !isFullscreen && (
          <AdminMenu visible={menuVisible} setVisible={setMenuVisible} abilities={abilities} />
        )}
        <div className={"content-children-wrp"}>{children}</div>
        <Aside auth={auth} />
      </div>
      {auth.user.main &&
        (location.pathname.startsWith("/dashboard") ||
          location.pathname.startsWith("/create/conversation")) && <Tabs />}
    </HandlingFocusedConversationHandler>
  );
});
